import React from "react";

import Category from "components/Tvendo/Article/DataMaster/Category/List.js";

export default function () {
  return <Category />;
}
